import {
	goodsSkuDetail,
	manjian,
	aftersale,
	modifyClicks,
	addGoodsbrowse,
	goodsSkuInfo,
	goodsQrcode
} from "@/api/goods/goods"
import {
	isCollect,
	addCollect,
	deleteCollect
} from "@/api/goods/goods_collect"
import {
	couponTypeList,
	couponReceive
} from "@/api/coupon"
import {
	bundlingList
} from "@/api/bundling"
import {
	goodsEvaluateList
} from "@/api/goods/evaluate"
import {
	mapGetters
} from "vuex"
import CountDown from "vue2-countdown"
import {
	shopIsSubscribe,
	addShopSubscribe,
	deleteShopSubscribe
} from "@/api/shop"
import {
	getArea
} from "@/api/address"
import {
	usedDetail
} from "@/api/cms/used"

export default {
	data: () => {
		return {
			skuId: 0,
			loading: true,

			// 店铺详情
			shopInfo: {},
			
			//
			id:null,
			detail:null,
			tabName: "detail",
		}
	},
	components: {
		// CountDown
	},
	created() {
		this.id = this.$route.params.pathMatch
		console.log(22222233333,this.id)
		this.getUsedDetail()
	},
	computed: {
		...mapGetters(["token", "defaultHeadImage", "defaultShopImage", "defaultGoodsImage", "addonIsExit", 'locationRegion'])
	},
	watch: {
		$route: function(curr) {
			this.skuId = curr.params.pathMatch
			this.getGoodsSkuDetail()
		}
	},
	methods: {
		tabChange(tab, event) {},
		bundlingChange(tab, event) {},
		
		// 商品二维码
		getGoodsQrcode() {
			goodsQrcode({
				sku_id: this.skuId
			}).then(res => {
				let data = res.data
				if (data.path.h5.img) this.qrcode = img(data.path.h5.img)
			})
		},
		
		// 图片加载失败
		imageErrorEvaluate(index) {
			this.goodsEvaluateList[index].member_headimg = this.defaultHeadImage
		},
		handlePageSizeChange(size) {
			this.pageSize = size
			this.getGoodsEvaluate()
		},
		handleCurrentPageChange(page) {
			this.currentPage = page
			this.getGoodsEvaluate()
		},
		
		// 立即购买
		buyNow() {
			//纠正数量
			this.keyInput(true, () => {
				if (this.goodsSkuDetail.stock == 0) {
					this.$message({
						message: "商品已售罄",
						type: "warning"
					})
					return
				}

				if (this.number.length == 0 || this.number == 0) {
					this.$message({
						message: "购买数量不能为0",
						type: "warning"
					})
					return
				}

				var data = {
					sku_id: this.skuId,
					num: this.number
				}

				this.$store.dispatch("order/setOrderCreateData", data)
				this.$router.push({
					path: "/payment"
				})
			})
		},
		see(){
			if(this.token){
				this.$alert(`联系人:${this.shopInfo.name},联系方式:${this.detail.tel || this.detail.email || this.detail.phone || this.shopInfo.telephone || this.shopInfo.mobile || this.shopInfo.email || '暂无'}`,'联系我时请提醒我从'+this.$config.title+'看到',  {
					confirmButtonText: '好的',
					
				});
			}else{
				this.$alert(`请登录查看`,'联系我时请提醒我从'+this.$config.title+'看到',  {
					confirmButtonText: '好的',
					// callback: action => {}
				});
			}
		},
		getUsedDetail(){
			usedDetail({
				id:this.id
			}).then(res=>{
				console.log(11111,res)
				if (res.code == 0 && res.data) {
					this.loading = false;
					this.detail = res.data;
					this.shopInfo = res.data.site
				} else {
					console.log(333)
					// this.$router.push({ path: '/cms/help' });
				}
			}).catch(err => {
				this.loading = false;
				this.$message.error(err.message);
			});
		}
	}
}
